import AboutUsSVG from '../../assets/svgs/About us.svg';

import classes from './SiderElement.module.scss';

export default function AboutUs({ text,  language }) {
  return (
    <div className={`${classes.link} ${classes[language]}`}>
      <span>
        <img src={AboutUsSVG} alt={text} className={classes.icon} />
      </span>
      <span className={classes['link-text']}>{text}</span>
    </div>
  );
}
